<template>
  <svg :x="x" :y="y" :width="`${widthInInches}in`" :height="`${heightInInches}in`" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <clipPath :id="`${uuid}-clip`">
        <rect :x="0" :y="0" :width="widthInInches" :height="heightInInches" />
      </clipPath>
    </defs>
    <rect v-if="allowUpload" x="0" y="0" :width="widthInInches" :height="heightInInches" fill="transparent" @click="$emit('upload-click')" class="clickable-area"/>
    <g v-if="allowUpload" :transform="`translate(${centerX}, ${centerY})`" @click="$emit('upload-click')">
      <circle class="allow-upload-icon" cx="0" cy="0" r="0.5" fill="transparent" stroke="#1d2019" stroke-width="0.02" />
      <line x1="-0.2" y1="0" x2="0.2" y2="0" stroke="#1d2019" stroke-width="0.02" />
      <line x1="0" y1="-0.2" x2="0" y2="0.2" stroke="#1d2019" stroke-width="0.02" />
    </g>
    <image v-else :href="imageUrl" :x="imageX" :y="imageY" :width="imageWidth" :height="imageHeight" :clip-path="`url(#${uuid}-clip)`"/>
  </svg>
</template>

<script>
import uuidv4 from "uuid/v4";
import { defaultMatThickness } from "../../hardCodedValues";

export default {
  props: {
    frameSpec: {
      type: Object,
      required: true
    },
    x: {
      type: Number,
      default: 0
    },
    y: {
      type: Number,
      default: 0
    },
    allowUpload: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      svgWidth: 0,
      svgHeight: 0
    };
  },
  mounted() {
    const svgRect = this.$el.getBoundingClientRect();
    this.svgWidth = svgRect.width;
    this.svgHeight = svgRect.height;
  },
  computed: {
    uuid() {
      return uuidv4();
    },
    artwork() {
      if (this.frameSpec) {
        return this.frameSpec.getArtwork();
      } else {
        return {};
      }
    },
    imageUrl() {
      if (!this.frameSpec) return "";

      const hasPng = this.artwork.customerSpecified && this.artwork.customerSpecified.url.includes(".png");
      const hasJpeg = this.artwork.customerSpecified && this.artwork.customerSpecified.url.includes(".jpeg");
      const hasBoth = hasPng && hasJpeg;
      const smallRendering = this.svgWidth < 300 || this.svgHeight < 300;

      if (hasBoth || !this.artwork.customerSpecified || smallRendering) {
        return this.artwork.croppedAndNormalized.url;
      } else {
        return this.artwork.customerSpecified.url;
      }
    },
    widthInInches() {
      return this.artwork.exterior.widthInInches;
    },
    heightInInches() {
      return this.artwork.exterior.heightInInches;
    },
    centerX() {
      return this.widthInInches / 2;
    },
    centerY() {
      return this.heightInInches / 2;
    },
    imageAspectRatio() {
      return this.artwork.croppedAndNormalized.dimensionsInPixels.width / this.artwork.croppedAndNormalized.dimensionsInPixels.height;
    },
    boxAspectRatio() {
      return this.widthInInches / this.heightInInches;
    },
    imageWidth() {
      if (this.imageAspectRatio > this.boxAspectRatio) {
        return this.heightInInches * this.imageAspectRatio;
      } else {
        return this.widthInInches;
      }
    },
    imageHeight() {
      if (this.imageAspectRatio > this.boxAspectRatio) {
        return this.heightInInches;
      } else {
        return this.widthInInches / this.imageAspectRatio;
      }
    },
    imageX() {
      return ((this.widthInInches - this.imageWidth) / 2) - defaultMatThickness;
    },
    imageY() {
      return ((this.heightInInches - this.imageHeight) / 2) - defaultMatThickness;
    }
  }
};
</script>

<style lang="scss" scoped>
svg {
  align-items: center;
  display: flex;
  height: auto;
  justify-content: center;
  max-width: 100%;
  width: 100%;

  .allow-upload-icon {
    cursor: pointer;
  }

  .clickable-area {
    cursor: pointer;
    pointer-events: all;
  }
}
</style>